export const accordionFAQ = (
	itemSelector = ".accordion-faq-item",
	headerSelector = ".accordion-faq-item-header",
	contentSelector = ".accordion-faq-item-content"
) => {

	const accordions = document.querySelectorAll(itemSelector);

	const openAccordion = (accordion) => {
		const content = accordion.querySelector(contentSelector);
		accordion.classList.add("active");
		content.style.maxHeight = content.scrollHeight + "px";
	};

	const closeAccordion = (accordion) => {
		const content = accordion.querySelector(contentSelector);
		accordion.classList.remove("active");
		content.style.maxHeight = null;
	};

	accordions.forEach((accordion) => {
		const header = accordion.querySelector(headerSelector);
		const content = accordion.querySelector(contentSelector);

		header.onclick = () => {
			if (content.style.maxHeight) {
				closeAccordion(accordion);
			} else {
				accordions.forEach(closeAccordion);
				openAccordion(accordion);
			}
		};
	});
};